export const veneerInventoryFilter = "veneerInventoryFilter";
export const veneerHistoryInventoryFilter = "veneerHistoryInventoryFilter";
export const faceInventoryFilter = "faceInventoryFilter";
export const coreInventoryFilter = "coreInventoryFilter";
export const coreHistoryFilter = "coreHistoryFilter";
export const logInventoryTabFilter = "logInventoryTabFilter";
export const logInventoryFilter = "logInventoryFilter";
export const logHistoryInventoryFilter = "logHistoryInventoryFilter";
export const flitchInventoryFilter = "flitchInventoryFilter";
export const flitchInventoryTabFilter = "flitchInventoryTabFilter";
export const flitchHistoryInventoryFilter = "flitchHistoryInventoryFilter";
export const plywoodInventoryTabFilter = "plywoodInventoryTabFilter";
export const veneerInventoryTabFilter = "veneerInventoryTabFilter";
export const mdfInventoryTabFilter = "mdfInventoryTabFilter";
export const faceInventoryTabFilter = "faceInventoryTabFilter";
export const faceHistoryTabFilter = "faceHistoryTabFilter";
export const coreInventoryTabFilter = "coreInventoryTabFilter";
export const fleeceInventoryTabFilter = "fleeceInventoryTabFilter";
export const otherGoodsInventoryTabFilter = "otherGoodsInventoryTabFilter";
export const fleeceInventoryFilter = "fleeceInventoryFilter";
export const fleeceHistoryFilter = "fleeceHistoryFilter";
export const otherGoodsInventoryFilter = "otherGoodsInventoryFilter";
export const otherGoodsHistoryFilter = "otherGoodsHistoryFilter";
export const mdfInventoryFilter = "mdfInventoryFilter";
export const mdfHistoryFilter = "mdfHistoryFilter";
export const plywoodInventoryFilter = "plywoodInventoryFilter";
export const plywoodHistoryFilter = "plywoodHistoryFilter";
export const transporterMasterFilter = "transporterMasterFilter";

//Master

// Vehicle Master
export const vehicleMasterFilter = "vehicleMasterFilter";
export const photoMasterTabFilter = "photoMasterTabFilter";
export const photoMasterFilter = "photoMasterFilter";
export const photoAlbumFilter = "photoAlbumFilter";
//Expenses
//Log-expenses
export const logExpensesFilter = "logExpensesFilter";
export const flitchExpensesFilter = "flitchExpensesFilter";
export const faceExpensesFilter = "faceExpensesFilter";
export const coreExpensesFilter = "coreExpensesFilter";
export const plywoodExpensesFilter = "plywoodExpensesFilter";
export const veneerExpensesFilter = "veneerExpensesFilter";
export const mdfExpensesFilter = "mdfExpensesFilter";
export const fleeceExpensesFilter = "fleeceExpensesFilter";
export const otherGoodsExpensesFilter = "otherGoodsExpensesFilter";

//Factory
//crosscutting
export const factoryCrosscutTabFilter = "factoryCrosscutTabFilter";
export const issueForCrosscuttingFilter = "issueForCrosscuttingFilter";
export const crosscuttingDoneFilter = "crosscuttingDoneFilter";
export const crosscuttingDoneHistoryFilter = "crosscuttingDoneHistoryFilter";

//Flitching
export const factoryFlitchingTabFilter = "factoryFlitchingTabFilter";
export const issueForFlitchingFilter = "issueForFlitchingFilter";
export const rejectedCrosscuttingFilter = "rejectedCrosscuttingFilter";
export const flitchingDoneFilter = "flitchingDoneFilter";
export const flitchingHistoryFilter = "flitchingHistoryFilter";

// Peeling
export const factoryPeelingTabFilter = "factoryPeelingTabFilter";
export const issueForPeelingFilter = "issueForPeelingFilter";
export const peelingDoneFilter = "PeelingDoneFilter";
export const peelingHistoryFilter = "PeelingHistoryFilter";
export const peelingWastageFilter = "PeelingWastageFilter";
export const rfForSlicingFilter = "RfForSlicingFilter";
export const reFlitchingDoneFilter = "ReFlitchingDoneFilter";
export const reFlitchingHistoryFilter = "ReFlitchingHistoryFilter";
//Slicing
export const factorySlicingTabFilter = "factorySlicingTabFilter";
export const issueForSlicingFilter = "issueForSlicingFilter";
export const slicingDoneFilter = "slicingDoneFilter";
export const slicingDoneApprovalFilter = "slicingDoneApprovalFilter";
export const issueForDressingFilter = "issueForDressingFilter";
export const issueForTappingFilter = "issueForTappingFilter";
export const tappingDoneFilter = "tappingDoneFilter";
export const tappingDamageFilter = "tappingDamageFilter";
export const slicingHistoryFilter = "slicingHistoryFilter";
export const slicingWastageFilter = "slicingWastageFilter";
export const tappingDoneHistoryFilter = "tappingDoneHistoryFilter";

// Dressing
export const dressingHistoryFilter = "dressingHistoryFilter";
export const mcMismatchDataFilter = "dressingHistoryFilter";
export const dressingDoneFilter = "dressingDoneFilter";

// Smoking & Dying
export const factorySmokingDyingTabFilter = "factorySmokingDyingTabFilter";
export const issueItemSmokingDyingTabFilter = "issueItemSmokingDyingTabFilter";
export const processDoneSmokingDyingTabFilter = "processDoneSmokingDyingTabFilter";
export const approvalSmokingDyingTabFilter = "approvalSmokingDyingTabFilter";
export const historySmokingDyingTabFilter = "historySmokingDyingTabFilter";

// Order
export const orderTabFilter = "orderTabFilter";
export const OrderRawOrderTabFilter = "OrderRawOrderTabFilter";
export const OrderRawApprovalTabFilter = "OrderRawApprovalTabFilter";
export const orderDecorativeOrderTabFilter = "orderDecorativeOrderTabFilter";
export const orderSeriesProductOrderTabFilter = "orderSeriesProductOrderTabFilter";
export const orderApprovalTabFilter = "orderApprovalTabFilter";
export const orderDecorativeApprovalTabFilter = "orderDecorativeApprovalTabFilter";
export const orderSeriesProductApprovalTabFilter = "orderSeriesProductApprovalTabFilter";

// Factory Grouping
export const issueForGroupingFilter = "issueForGroupingFilter";
export const factoryGroupingTabFilter = "factoryGroupingTabFilter";
export const groupingDoneFilter = "groupingDoneFilter";
export const groupingDamageFilter = "groupingDamageFilter";
export const groupingHistoryFilter = "groupingHistoryFilter";

//Approval
export const logApprovalFilter = "logApprovalFilter";
export const flitchApprovalFilter = "flitchApprovalFilter";
export const plywoodApprovalFilter = "plywoodApprovalFilter";
export const veneerApprovalFilter = "veneerApprovalFilter";
export const mdfApprovalFilter = "mdfApprovalFilter";
export const faceApprovalFilter = "faceApprovalFilter";
export const coreApprovalFilter = "coreApprovalFilter";
export const fleeceApprovalFilter = "fleeceApprovalFilter";
export const otherGoodsApprovalFilter = "otherGoodsApprovalFilter";
export const crosscuttingDoneApprovalFilter = "crosscuttingDoneApprovalFilter";
export const flitchingDoneApprovalFilter = "flitchingDoneApprovalFilter";

//
export const factoryReSizingPlywoodTabFilter = "factoryReSizingPlywoodTabFilter";
export const issueForReSizingPlywoodFilter = "issueForReSizingPlywoodFilter";
export const reSizingPlywoodDoneFilter = "reSizingPlywoodDoneFilter";
export const reSizingPlywoodHistoryFilter = "reSizingPlywoodHistoryFilter";
export const reSizingPlywoodDamageFilter = "reSizingPlywoodDamageFilter";
//Plywood Production
export const plywoodProductionTabFilter = "plywoodProductionTabFilter";
export const plywoodProductionDoneFilter = "plywoodProductionDoneFilter";
export const plywoodProductionHistoryFilter = "plywoodProductionHistoryFilter";
export const plywoodProductionDamageFilter = "plywoodProductionDamageFilter";

// CNC
export const factoryCncTabFilter = "factoryCncTabFilter";
export const issueForCncFilter = "issueForCncFilter";
export const cncDoneFilter = "cncDoneFilter";
export const cncDamageFilter = "cncDamageFilter";
export const cncHistoryFilter = "cncHistoryFilter";

// Pressing
export const factoryPressingTabFilter = "factoryPressingTabFilter";
export const issueForPressingFilter = "issueForPressingFilter";
export const pressingDoneFilter = "pressingDoneFilter";
export const pressingDamageFilter = "pressingDamageFilter";
export const pressingHistoryFilter = "pressingHistoryFilter";

// Bunito
export const factoryBunitoTabFilter = "factoryBunitoTabFilter";
export const issueForBunitoFilter = "issueForBunitoFilter";
export const bunitoDoneFilter = "bunitoDoneFilter";
export const bunitoDamageFilter = "bunitoDamageFilter";
export const bunitoHistoryFilter = "bunitoHistoryFilter";

// Colour
export const factoryColourTabFilter = "factoryColourTabFilter";
export const issueForColourFilter = "issueForColourFilter";
export const colourDoneFilter = "colourDoneFilter";
export const colourDamageFilter = "colourDamageFilter";
export const colourHistoryFilter = "colourHistoryFilter";

// Canvas
export const factoryCanvasTabFilter = "factoryCanvasTabFilter";
export const issueForCanvasFilter = "issueForCanvasFilter";
export const canvasDoneFilter = "canvasDoneFilter";
export const canvasDamageFilter = "canvasDamageFilter";
export const canvasHistoryFilter = "canvasHistoryFilter";

// Polishing
export const factoryPolishingTabFilter = "factoryPolishingTabFilter";
export const issueForPolishingFilter = "issueForPolishingFilter";
export const polishingDoneFilter = "polishingDoneFilter";
export const polishingDamageFilter = "polishingDamageFilter";
export const polishingHistoryFilter = "polishingHistoryFilter";

// Challan
export const challanTabFilter = "challanTabFilter";
export const issueForChallanFilter = "issueForChallanFilter";
export const challanFilter = "challanFilter";

//Dispatch
export const dispatchTabFilter = "dispatchTabFilter";
export const dispatchListingFilter = "dispatchListingFilter";
export const dispatchHistoryFilter = "dispatchHistoryFilter";
export const dispatchApprovalFilter = "dispatchApprovalFilter";

//Packing
export const packingFilter = "packingFilter"
export const packingFinishedFilter = "packingFinishedFilter"
export const packingRawFilter = "packingRawFilter"
export const packingDoneFilter = "packingDoneFilter"
export const packingApprovalFilter = "packingApprovalFilter"

// Series Product Master
export const barcodeFilter = "barcodeFilter";
export const chromaCollectionFilter = "chromaCollectionFilter";
export const chromaCompositeFilter = "chromaCompositeFilter";
export const chromaRibbedFilter = "chromaRibbedFilter";
export const bunitoFilter = "bunitoFilter";
export const mattleFilter = "mattleFilter";
export const canvasFilter = "canvasFilter";
export const novelFilter = "novelFilter";
export const marvelFilter = "marvelFilter";
export const regantoDezinerFilter = "regantoDezinerFilter";
export const regantoClassicFilter = "regantoClassicFilter";
export const regantoPremierFilter = "regantoPremierFilter";
export const furrowFilter = "furrowFilter";
export const furrowLiteFilter = "furrowLiteFilter";
export const furrowRegantoFilter = "furrowRegantoFilter";
export const accoFilter = "accoFilter";
